import React from 'react';
import './svg.css';

const ArrowIcon = (props) => {
  return (

    <svg
      automationid={`SalesLead_Svg_${props.automationidattr}ArrowIcon_0`}
      className={`arrow-icon ${props.direction} ${props.colorClass}`} width="10px" height="10px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 144 76" id="icon-chevron-down">
      <title>main_icn_Chevron_down</title>
      <polyline id="chevron-down-00134c7b-b10c-486b-af1b-ea0801b1e1c2" data-name="<Pfad>" points="140 4 72 72 4 4"
        strokeLinecap="round" strokeLinejoin="round"></polyline>
    </svg>

  )
}

export default ArrowIcon;